var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style["g-head"] },
    [
      _c(
        "div",
        {
          staticClass: "m-container",
          class: [
            _vm.$style["m-container"],
            this.$route.query.isApp == 1 ? "autoHeight" : ""
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "flex justify-between",
              class: _vm.$style["container-inner"]
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex justify-start items-center",
                  class: _vm.$style["state--pos-left"]
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "flex items-center",
                      class: _vm.$style["nav-logo"],
                      attrs: { href: "/" }
                    },
                    [
                      _c("img", {
                        class: _vm.$style["logo-img"],
                        attrs: {
                          src: require("../../assets/images/newLogoV3.png"),
                          alt: "superex"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex justify-end items-center",
                  class: _vm.$style["state--pos-right"]
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "grid",
                      class: _vm.$style["btn-group--text"]
                    },
                    _vm._l(_vm.textBtns, function(item) {
                      return _c(
                        "button",
                        {
                          key: item.type,
                          staticClass: "flex justify-center items-center",
                          class: _vm.$style["btn-item"],
                          attrs: { "data-type": item.type },
                          on: {
                            click: function($event) {
                              return _vm.goRegister()
                            }
                          }
                        },
                        [
                          _c("span", { class: _vm.$style["text"] }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("300041")) +
                                "\n                        "
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "open btn-open-lang",
                      class: _vm.$style["btn--open-fold-nav"],
                      on: {
                        click: function($event) {
                          _vm.showLanguageSwitch = true
                        }
                      }
                    },
                    [
                      _c("div", { class: _vm.$style["btn--inner"] }, [
                        _c("div", { class: _vm.$style["line"] }),
                        _vm._v(" "),
                        _c("div", { class: _vm.$style["line"] }),
                        _vm._v(" "),
                        _c("div", { class: _vm.$style["line"] })
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { css: false },
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            leave: _vm.leave
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showLanguageSwitch,
                  expression: "showLanguageSwitch"
                }
              ],
              staticClass: "olololol",
              class: _vm.$style["inner"]
            },
            [
              _c(
                "div",
                { staticClass: "nnnn", class: _vm.$style["lang-switch-head"] },
                [
                  _c(
                    "button",
                    {
                      staticClass: "flex justify-center items-center",
                      class: _vm.$style["btn--close-fold-nav"],
                      on: { click: _vm.closeLangModal }
                    },
                    [
                      _c("UeIcon", {
                        class: _vm.$style["ic"],
                        attrs: { name: "x-close" }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("LanguageSwitch", {
                ref: "LanguageSwitch",
                attrs: { isShow: _vm.showLanguageSwitch },
                on: { closeLangModal: _vm.closeLangModal }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1caa8ccf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1caa8ccf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/InCompleteSiteHead.vue
// module id = fbQf
// module chunks = 0